import { render, staticRenderFns } from "./ExternalChangesList.vue?vue&type=template&id=00c1b947&scoped=true&"
import script from "./ExternalChangesList.vue?vue&type=script&lang=js&"
export * from "./ExternalChangesList.vue?vue&type=script&lang=js&"
import style0 from "./ExternalChangesList.vue?vue&type=style&index=0&id=00c1b947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c1b947",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
